import React from "react";

import ImageListCard from "../../components/image-list-card/ImageListCard";
import CardImage from "./card-image.svg";
import styles from './CardCarouselSection.module.scss';
import type {ImageListCardData} from "../../types";
import H1 from "../../components/typography/H1";
import H4 from "../../components/typography/H4";
import List1 from "../../components/typography/List1";
import {EMOJIS} from "../../../../../config/constants";
import {useWindowWidth} from "../../../../../services/useWindowWidth";

const cards: ImageListCardData[] = [
    {
        image: CardImage,
        title: 'Shipping lines',
        list: [
            'Integrate rates via API or your account. Your rates are automatically included in the total cost calculation',
            'Reach clients directly. Your services are visible when clients make their final decision',
            'Spend less on processing inquiries. Receive requests with comprehensive details from the start'
        ]
    },
    {
        image: CardImage,
        title: 'Freight forwarders',
        list: [
            'Build complete routes. Create tailored end-to-end solutions that include your forwarding services',
            'Collaborate with partners. Work with declarants, customs brokers and insurers within a single client order',
            'Showcase your expertise. Become a key partner in a transparent cost breakdown of the entire import process'
        ]
    },
    {
        image: CardImage,
        title: 'Benefits for everyone',
        list: [
            'Real-time market insights. See demand by route and average market rates',
            'Standardized document workflows. Store and approve all documents for each deal on the platform',
            'Fewer operational errors. Reduce risks caused by incomplete or inaccurate client information'
        ]
    }
];

function CardCarouselSection() {
    const width = useWindowWidth();
    const isSmallScreen = width >= 576 && width <= 1199;

    return (
        <div className={styles.section} id="benefits">
            <div className={styles.sectionContainer}>
                <div className={styles.title}>
                    <H1>What Vedmarket offers</H1>
                </div>
                {!isSmallScreen && <div className={styles.cardsContainer}>
                    {cards.flatMap((card, index) => [
                        <ImageListCard key={`card-${index}`} card={card} />,
                        ...(index < cards.length - 1 ? [
                            <span
                                aria-hidden="true"
                                className={styles.cardGap}
                                key={`gap-${index}`}
                            />,
                        ] : []),
                    ])}
                </div>}
                {isSmallScreen && <div className={styles.smCards}>
                    {cards.map((card, index) => (
                        <div className={styles.smCard} key={index}>
                            <H4
                                className={styles.smCardTitle}
                                sx={{
                                    '@media (min-width: 576px) and (max-width: 767px)': {
                                        position: 'relative',
                                        top: '3px',
                                        overflowWrap: 'normal',
                                        textWrap: 'wrap',
                                    },
                                }}
                            >
                                {card.title}
                            </H4>
                            <ul className={styles.smCardList}>
                                {card.list.map((item, itemIndex) => (
                                    <li className={styles.smCardItem} key={itemIndex}>
                                        <span className={styles.smCardEmoji} aria-hidden="true">
                                            {EMOJIS.BACKHAND_INDEX_POINTING_RIGHT_LIGHT}
                                        </span>
                                        <List1
                                            className={styles.smCardText}
                                        >
                                            {item}
                                        </List1>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>}
            </div>
        </div>
    );
}

export default CardCarouselSection
